import { Button, Container, Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Form from 'react-bootstrap/Form';
import { useState } from "react";
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { FaPlus } from "react-icons/fa6";
import { IoHomeOutline } from "react-icons/io5";
import { CreateDeduction, DeleteDeduction, EditDeduction, GetAllDeduction } from "../../utils/proxy/DeductionMasterProxy";
import { Op_per } from "../../utils/Permissions";

function DeductionMaster() {

    const [show, setShow] = useState(false);
    const [showedit, setShowedit] = useState(false);
    const [reload, SetReload] = useState(false);
    const [data, setData] = useState();

    const [id, setId] = useState();
    const [name, setName] = useState();
    const [amount, setAmount] = useState();
    const [description, setDescription] = useState();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        const getall = async () => {
            let d = await GetAllDeduction();
            if (d) {
                setData(d);
            } else {
                alert('Error', 'Issues while fetching data')
            }
        }
        getall()
        SetReload(false);
    }, [reload])

    const handleSave = async () => {
        if (name == null || name == '') {
            Swal.fire({
                title: "Warning!",
                text: "Enter Deduction Name !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if (amount == null || amount == '') {
            Swal.fire({
                title: "Warning!",
                text: "Enter Amount !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else {
            let d = await CreateDeduction(name,amount, description);
            if (d.status === 'success') {
                setShow(false);
                SetReload(true);
                setName(null);
                setAmount(null);
                setDescription(null);
                Swal.fire({
                    title: "Success!",
                    text: "New Deduction Added !!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            }
        }
    }

    const handledelete = async (id) => {
        let d = await DeleteDeduction(id);
        if (d.status === 'success') {
            SetReload(true);
            Swal.fire({
                title: "Success!",
                text: "Deduction Deleted !!",
                icon: "success",
                confirmButtonText: "OK",
            });
        }
    }

    const handleEditShow = (row) => {

        setShowedit(true);
        setId(row.id);
        setName(row.name);
        setAmount(row.amount)
        setDescription(row.description);
    }

    const handleEditSave = async () => {
        if (name == null || name == '') {
            Swal.fire({
                title: "Warning!",
                text: "Enter Deduction Name !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if (amount == null || amount == '') {
            Swal.fire({
                title: "Warning!",
                text: "Enter Amount !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else {
            let d = await EditDeduction(id, name,amount,description);
            if (d.status === 'success') {
                setShowedit(false);
                SetReload(true);
                setId(null);
                setName(null);
                setAmount(null);
                setDescription(null);
                Swal.fire({
                    title: "Success!",
                    text: "Deduction Edited !!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            }
        }
    }

    const columns = [
        // {
        //     name: "Id",
        //     selector: (row) => row.id,
        //    
        
        // },
        {
            name: "Name",
            selector: (row) => <div style={{ whiteSpace: 'normal',backgroundColor: row.name === "" || row.name === null ? "#f36e6f":"", borderRadius:"10px", border: row.name === "" || row.name === null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.name === "" || row.name === null ? "#fff": "#000", margin:"3px", }}>{row.name ? row.name : "N/A"}</div>,
      
            //width:"15%",
           
            fontSize: 10,
            fontWeight:'bold',
        },
        {
            name: "Amount",
            selector: (row) => <div style={{ whiteSpace: 'normal',backgroundColor: row.amount === "" || row.amount === null ? "#f36e6f":"", borderRadius:"10px", border: row.amount === "" || row.amount === null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.amount === "" || row.amount === null ? "#fff": "#000", margin:"3px", }}>{row.amount ? row.amount : "N/A"}</div>,
      
            //width:"15%",
           
            fontSize: 10,
            fontWeight:'bold',
        },
        {
            name: "Description",
            selector: (row) =><div style={{ whiteSpace: 'normal',backgroundColor: row.description === "" || row.description === null ? "#f36e6f":"", borderRadius:"10px", border: row.description === "" || row.description === null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.description === "" || row.description === null ? "#fff": "#000", margin:"3px", }}>{row.description ? row.description : "N/A"}</div>,
      
            //width:"15%",
           
            fontSize: 10,
            fontWeight:'bold',
        },
    ];

    const customStyles = {   head: {     style: {       backgroundColor: 'blue',     },   }, };
    const CustomHeader = ({ children }) => (   <div style={{ backgroundColor: 'blue', padding: '10px', color: 'white' }}>    {children}  </div>);
    
    if (Op_per.get().HR_DEDUCTION_MASTER.ALLOW_EDIT || Op_per.get().HR_DEDUCTION_MASTER.ALLOW_DELETE) {
        columns.push({
            name: "Actions",
            selector: (row) => (
                <div key={row.id}>
                    <AiFillDelete
                        onClick={() => handledelete(row.id)}
                        style={{ color: "#f36e6f", fontSize: 20 }}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <AiTwotoneEdit
                        onClick={() => handleEditShow(row)}
                        style={{ color: "#9889e6", fontSize: 20 }}
                    />
                </div>
            ),
        })
    }

    return (
        <Container fluid style={{ minHeight: "80vh" }}>
            <div
                className="glass-body"
                style={{
                    margin: 10,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding:0,
          backgroundColor:'transparent'
        }}
      >

<div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
<ul id="breadcrumb">
  <li><a href="/"><IoHomeOutline
            style={{ color: "white", fontSize: 20 }}
            
          /></a></li>
  <li><a href="/leavetype-master"><span class="icon icon-beaker"> </span>HR</a></li>
  <li><a href="/leavetype-master"><span class="icon icon-beaker"> </span>Deduction Master</a></li>
  {/* <li><a href="#"><span class="icon icon-double-angle-right"></span>Doctor</a></li> */}
  
</ul>
	
</div>
            </div>
            <div className="glass-body" style={{ margin: 10 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                    className="flex-column-mobile"
                >
                    <div>
                        <Form.Control
                            className="glass"
                            placeholder="Search"
                            type="text"
                            style={{ display: 'none' }}
                        //   value={searchQuery}
                        //   onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <div>
                        {Op_per.get().HR_DEDUCTION_MASTER.ALLOW_ADD ? (
                            <Button style={{backgroundColor: "#2194f0" }} onClick={handleShow}>
                                <FaPlus />
                            </Button>
                        ) : ("")}
                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <DataTable
                        columns={columns}
                        data={data}
                        // progressPending={pending}
                        // selectableRows
                        // onSelectedRowsChange={({ selectedRows }) =>
                        // setSelectedRows(selectedRows)
                        //   }
                        pagination
                        customStyles={{headRow: {style: {backgroundColor: '#c0dfff',  padding:10,borderRadius:'10px 10px 0 0' }, }  }}
                        CustomHeader={<CustomHeader/>}
                        // actions={actionsMemo}
                        style={{ marginTop: 10 }}
                        // progressPending={pending}
                        // progressComponent={<LoadingComponent/>}
                        dense
                    />
                </div>
            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Deduction</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Name <span style={{color:"red"}} >*</span></Form.Label>
                            <Form.Control
                            style={{height: 40,
           
           borderColor: '#ccc',
           borderWidth: 1,
           paddingHorizontal: 8,
           marginBottom: 16,
           borderRadius:10,}}
                                type="text"
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter Deduction Name"
                                required
                            />
                        </Form.Group>
                        <Form.Label>Amount <span style={{color:"red"}} >*</span></Form.Label>
                        <Form.Control
                        style={{height: 40,
           
           borderColor: '#ccc',
           borderWidth: 1,
           paddingHorizontal: 8,
           marginBottom: 16,
           borderRadius:10,}}
                            type="number"
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter Amount"
                        />
                        <Form.Label>Description <span style={{color:"red"}} >*</span></Form.Label>
                        <Form.Control
                        style={{height: 80,
           
           borderColor: '#ccc',
           borderWidth: 1,
           paddingHorizontal: 8,
           marginBottom: 16,
           borderRadius:10,}}
                            type="text"
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter Description"
                        />
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showedit} onHide={() => setShowedit(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Deduction</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Name <span style={{color:"red"}} >*</span></Form.Label>
                            <Form.Control
                            style={{height: 40,
           
           borderColor: '#ccc',
           borderWidth: 1,
           paddingHorizontal: 8,
           marginBottom: 16,
           borderRadius:10,}}
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter Expense Type Name"
                                required
                            />
                        </Form.Group>
                        <Form.Label>Amount <span style={{color:"red"}} >*</span></Form.Label>
                        <Form.Control
                        style={{height: 40,
           
           borderColor: '#ccc',
           borderWidth: 1,
           paddingHorizontal: 8,
           marginBottom: 16,
           borderRadius:10,}}
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter Amount"
                        />
                        <Form.Label>Description <span style={{color:"red"}} >*</span></Form.Label>
                        <Form.Control
                        style={{height: 80,
           
           borderColor: '#ccc',
           borderWidth: 1,
           paddingHorizontal: 8,
           marginBottom: 16,
           borderRadius:10,}}
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter Description"
                        />
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowedit(false)}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleEditSave}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

        </Container>
    )
}

export default DeductionMaster;